// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-page {
  background: var(--bg-primary);
  padding-top: 80px;
}

.legal-container {
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem 1.5rem 3rem;
}

.legal-title {
  font-size: 1.8rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 1.5rem;
}

.legal-section {
  margin-bottom: 1.5rem;
}

.legal-section h2 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
}

.legal-section p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.7;
  margin: 0 0 0.5rem;
}

.legal-section ul {
  padding-left: 1.25rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.7;
}

.legal-section a {
  color: var(--accent-primary);
}

.legal-contact {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 10px;
  padding: 1.25rem;
  margin-top: 1.5rem;
}

.legal-contact h3 {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
}

.legal-contact p {
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.6;
  margin: 0 0 0.25rem;
}

@media (max-width: 680px) {
  .legal-container {
    padding: 1.5rem 1rem 2rem;
  }

  .legal-title {
    font-size: 1.4rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/legal/LegalPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".legal-page {\r\n  background: var(--bg-primary);\r\n  padding-top: 80px;\r\n}\r\n\r\n.legal-container {\r\n  max-width: 700px;\r\n  margin: 0 auto;\r\n  padding: 2rem 1.5rem 3rem;\r\n}\r\n\r\n.legal-title {\r\n  font-size: 1.8rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary);\r\n  margin: 0 0 1.5rem;\r\n}\r\n\r\n.legal-section {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.legal-section h2 {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.legal-section p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  line-height: 1.7;\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.legal-section ul {\r\n  padding-left: 1.25rem;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n.legal-section a {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.legal-contact {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.legal-contact h3 {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 0.5rem;\r\n}\r\n\r\n.legal-contact p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  line-height: 1.6;\r\n  margin: 0 0 0.25rem;\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .legal-container {\r\n    padding: 1.5rem 1rem 2rem;\r\n  }\r\n\r\n  .legal-title {\r\n    font-size: 1.4rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
